import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { iterateStringEnum } from "../../../../../lib/enums"
import { CreditNoteType } from "../helpers"

type Props = Readonly<{
    value: CreditNoteType
    onChange: (event: SelectChangeEvent<CreditNoteType>) => void
    className?: string
}>

export function CreditNoteTypeSelect({ value, onChange, className }: Props) {
    return (
        <FormControl>
            <LocalizedStrict id="production-credit-note-select-label">
                <InputLabel id="credit-note-select-label">Create</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="table-select-date-period-filter-by-label-label">
                <Select<CreditNoteType>
                    id="credit-note-select"
                    labelId="credit-note-select-label"
                    value={value}
                    onChange={onChange}
                    label="Create"
                    placeholder="Select type"
                    className={className}
                >
                    {[...iterateStringEnum(CreditNoteType)].map((val) => (
                        <MenuItem key={val} value={val}>
                            <LocalizedEnum base="production-credit-note-table-column-type-cell" enumValue={val}>
                                <span>{val}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
